export const RULE_EFFECTS = ['block', 'warn', 'info'] as const;
export type RuleEffect = (typeof RULE_EFFECTS)[number];

/** Content shape of a rule's `definition`. `interference` is the only kind today. */
export const RULE_KINDS = ['interference'] as const;
export type RuleKind = (typeof RULE_KINDS)[number];

export const ENTITY_TYPES = ['Duct', 'Beam', 'ArchitecturalWall', 'StructuralColumn', 'StructuralWall'] as const;
export type EntityType = (typeof ENTITY_TYPES)[number];

export const TOPOLOGY_KINDS = ['Touching'] as const;
export type TopologyKind = (typeof TOPOLOGY_KINDS)[number];

export interface TargetEntity {
    entityType: EntityType;
}

export interface InterferenceDefinition {
    type: 'Interference';
    firstEntity: TargetEntity;
    secondEntity: TargetEntity | null;
    topologies: TopologyKind[];
    overlapToleranceCm3: number | null;
    minClearanceCm: number | null;
}

export interface InterferenceRuleInput {
    name: string;
    effect: RuleEffect;
    definition: InterferenceDefinition;
}

export interface InterferenceRule extends InterferenceRuleInput {
    object_id: string;
    kind: 'interference';
    supports_inline: boolean;
    created_at: string;
}

/**
 * A rule as seen from a project it's assigned to. `created_by` is the rule's
 * org-scope author, not whoever assigned it to this project.
 */
export interface AssignedRule {
    rule: InterferenceRule;
    created_by: string;
    assigned_at: string;
}
